<template>
  <div v-if="isLoading" class="loader-container">
    <v-progress-circular
      indeterminate
      color="primary"
      :size="64"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
    props:['isLoading']
};
</script>

<style>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(237, 234, 234, 0.374);
  z-index: 9999;
}
</style>
